import React, { useEffect, useState } from "react";
import { FaMotorcycle } from "react-icons/fa";
import { MdDirectionsCar, MdLocalShipping, MdOpenInNew } from "react-icons/md";
import styles from "./Categories.module.css";
import { useNavigate } from "react-router-dom";
import useHeroAPI from "../../../api/useHeroAPI";
import twoWheelerImg from "../../../assets/images/bikeimage.jpg";
import truckImg from "../../../assets/images/truckimage.jpg";
import carImg from "../../../assets/images/Car.jpg";
interface CategoriesProps {
  code: string;
}

const iconForSegment = (name: string = "") => {
  const lower = name.toLowerCase();
  if (lower.includes("two") || lower.includes("2w")) {
    return (
      <div className={styles.iconWrapper}>
        <FaMotorcycle size={28} />
      </div>
    );
  }
  if (lower.includes("truck") || lower.includes("commercial")) {
    return (
      <div className={styles.iconWrapper}>
        <MdLocalShipping size={28} />
      </div>
    );
  }
  return (
    <div className={styles.iconWrapper}>
      <MdDirectionsCar size={28} />
    </div>
  );
};

// const bgImageForSegment = (name: string = "") => {
//   const lower = name.toLowerCase();
//   if (lower.includes("two") || lower.includes("2w")) {
//     return {
//       src: "https://lh3.googleusercontent.com/aida-public/AB6AXuDt6kGjFYwyrE5RfpoLiY6lU4dBFmZiOiy9pgo4uHGlQ-sjGVCgVXROqaTxFpLeDghMZGhCSaCOnrzml0T0JYPsxXE0Fn49HkF4P8OmSOCYBp7ny85-smQgFNI6aqTXOvOAtCHqz9sIIpjSiiiFsm9HAkN4t_Q-IxSkOIOa5xTTmaopXr4m6yvot_xe7cAmAISIzzfGvH5W_avYV9tCMZdZ3qX4HNTNsQQDWOnCCjd1jEfnETxwp1NNCDfB7BECNts_-olAAV5Yxg",
//       fallback: twoWheelerImg,
//     };
//   }
//   if (lower.includes("truck") || lower.includes("commercial")) {
//     return {
//       src: "https://lh3.googleusercontent.com/aida-public/AB6AXuBq_H3yRVh7i1HsDAoxYjTpv_6SRz9e0fOAUjJecpc68dzaW4LMGcpvbbcQAI3wCJTOHPx2VLeLPAyv9LGX0ehOZDF__YU5xda2N1SW--CdWCiUwqEGTQHZ5qMfLO8tQDHwxYExoyjsZr9lbRfXkGrzQhlB24meLI1X7eeMCC2y-s9o0qwFfhTqSLzresT6edgtZegixHR08a-63DJ4TkE_dCRDLZJhy9yNItnvfar7OL-RW2u0jWPVwxsw01bCiISyoc2m6Ckpdg",
//       fallback: truckImg,
//     };
//   }
//   return {
//     src: "https://lh3.googleusercontent.com/aida-public/AB6AXuAGA_ylaCXbXyNlwLm-7CZr_z3XrrD9qdUNeC_MBpsapZM69jlZn6wJduxYbsrMVcbKS_MsrY3UHRB3DC8Nh7hHzyhZYBbVfj92X1qqhXH6SI5B4kcG0nZg_PmbuVhbEXWUai1KsSNFBQPhT8_kltBzZR82sJ6Q1mXL5zjQJprGP93883ClUUndFSQ-Qvz62_Fu336wFEs4VOV2zsMieI_7dZZxkrKvqItKje0StsknZgks5gsL9iSLBJWeQc-CCulgJOualhBeLg",
//     fallback: carImg,
//   };
// };
const bgImageForSegment = (name: string = "") => {
  const lower = name.toLowerCase();

  if (
    lower.includes("two") ||
    lower.includes("2w") ||
    lower.includes("bike") ||
    lower.includes("motorcycle")
  ) {
    return twoWheelerImg;
  }

  if (lower.includes("truck") || lower.includes("commercial")) {
    return truckImg;
  }

  return carImg;
};
const descForSegment = (name: string = "") => {
  const lower = name.toLowerCase();
  if (lower.includes("two") || lower.includes("2w")) {
    return "Precision grip for street and track usage.";
  }
  if (lower.includes("truck") || lower.includes("commercial")) {
    return "Maximum durability for long-haul logistics.";
  }
  return "Comfort and safety for daily commutes.";
};

export default function Categories({ code }: CategoriesProps) {
  // console.log("hellloooooooooooo");
  const navigate = useNavigate();
  const basePath = process.env.REACT_APP_BASE_PATH || "/";
  const { predefinedFunc } = useHeroAPI();

  const [categories, setCategories] = useState<any[]>([]);
  const [productType, setProductType] = useState<any>(null);

  useEffect(() => {
    const loadCategories = async () => {
      // console.log("CATEGORIES: code prop received =", code);

      const productTypeResponse = await predefinedFunc({
        entity_type: "PRODUCT-TYPE",
        code,
      });

      // console.log(productTypeResponse, "result>>>>>>>>>>>>>>>>>>>>>");
      const resolvedProductType = productTypeResponse?.data?.data?.[0] ?? null;
      setProductType(resolvedProductType);

      if (!resolvedProductType?.predefined_id) return;

      const categoryResponse = await predefinedFunc({
        entity_type: "CATEGORY",
        categoryParentID: resolvedProductType.predefined_id,
      });
      setCategories(categoryResponse?.data?.data || []);
    };

    if (code) {
      loadCategories();
    }
  }, [code]);

  return (
    <section className={styles.categoriesSection}>
      <div className={styles.headerRow}>
        <div className={styles.titleGroup}>
          <h2 className={styles.sectionTitle}>Vehicle Categories</h2>
          <p className={styles.sectionSubtitle}>
            Optimized fitment for every vehicle class, from high-performance
            superbikes to heavy-duty commercial logistics fleets.
          </p>
        </div>
      </div>

      <div className={styles.grid}>
        {categories.map((cat: any, idx: number) => (
          <button
            key={cat.predefined_id ?? idx}
            className={styles.cardBtn}
            onClick={() =>
              navigate(`${basePath}products`, {
                state: {
                  code,
                  tyreType: cat,
                  category_ids: [cat.predefined_id],
                  product_type_id: productType?.predefined_id,
                },
              })
            }
          >
            <div
              className={styles.cardBg}
              style={{ backgroundImage: `url(${bgImageForSegment(cat.name)})` }}
            />
            <div className={styles.cardOverlay} />
            <div style={{ height: "200px", borderRadius: "10px" }}>
              {iconForSegment(cat.name)}
              <h3 className={styles.cardTitle}>{cat.name}</h3>
              <p className={styles.cardDesc}>{descForSegment(cat.name)}</p>
              <button
                className={styles.cardBtn}
              >{`Explore ${cat.name}`}</button>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
}
